var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.FormLayout,{attrs:{"is-loading":_setup.props.isLoading ?? false,"title":"Location not found.","overline":"Error"},on:{"on-dismiss":_setup.handleDismiss}})
}
var staticRenderFns = []

export { render, staticRenderFns }